export const Coins = (value: any) => {
  return Number.parseInt(value.toString().replace(/\s/g, ''))
}
